import Typography from '@mui/material/Typography';
import { Icon, IconName } from '@packages/shared-ui';
import useStyles from './CheckoutStepper.styles';

const STEPS = ['Select your product', 'Sign agreements', 'Checkout'];

interface Props {
  currentStep: number;
}

export default function CheckoutStepper({ currentStep }: Props) {
  const { classes, cx } = useStyles();

  return (
    <ol className={classes.root} aria-label='Checkout progress'>
      {STEPS.map((label, index) => {
        const step = index + 1;
        const isCurrent = step === currentStep;
        const isComplete = step < currentStep;

        return (
          <li
            key={label}
            className={cx(classes.step, isComplete && classes.stepComplete)}
            aria-current={isCurrent ? 'step' : undefined}
          >
            <span
              className={cx(
                classes.marker,
                (isCurrent || isComplete) && classes.markerFilled,
                isCurrent && classes.markerCurrent
              )}
              aria-hidden
            >
              {isCurrent && (
                <Typography variant='h4' component='span' color='inherit'>
                  {step}
                </Typography>
              )}
              {isComplete && <Icon name={IconName.CHECK_MARK} width={24} />}
            </span>
            <span className={classes.copy}>
              <Typography
                variant='note'
                component='span'
                color='semantic.text.secondary'
              >
                {`Step ${step}`}
              </Typography>
              <Typography variant='bodyLg' component='span'>
                {label}
              </Typography>
              {isComplete && (
                <Typography
                  variant='note'
                  component='span'
                  color='semantic.text.secondary'
                >
                  Complete
                </Typography>
              )}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
